import { render, staticRenderFns } from "./BudgetObjecEdit.vue?vue&type=template&id=20b963d4&scoped=true&"
import script from "./BudgetObjecEdit.vue?vue&type=script&lang=js&"
export * from "./BudgetObjecEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b963d4",
  null
  
)

export default component.exports